import type { TOnCallType } from "models/OnCallIntegrationScheduleModel";
import type { TTicketingIntegrationType } from "models/TicketingIntegrationTicketModel";

import { CompanyModel } from "models/CompanyModel";
import { apiReq } from "utils/api/apiReq";

export type THRType = "BambooHR" | "Freshteam" | "Hibob" | "Workday";

export type TOnCallCredentials = {
  apiId?: string;
  apiKey?: string;
  clientId?: string;
  clientSecret?: string;
  instanceUrl?: string;
};

export async function addHRIntegration(hrType: THRType, publicToken: string, uuid: string) {
  const { data } = await apiReq("POST", `/v1/company/hrIntegrations/${hrType}`, { configurationId: uuid, publicToken });

  return CompanyModel.fromServerData(data);
}

export async function addOnCallIntegration(onCallType: TOnCallType, credentials: TOnCallCredentials) {
  const { apiId, apiKey, clientId, clientSecret, instanceUrl } = credentials;
  const { data } = await apiReq("POST", `/v1/company/onCallIntegrations/${onCallType}`, {
    ...(apiKey ? { apiKey } : {}),
    ...(apiId ? { apiId } : {}),
    ...(instanceUrl ? { instanceUrl } : {}),
    ...(clientId ? { clientId } : {}),
    ...(clientSecret ? { clientSecret } : {}),
  });

  return CompanyModel.fromServerData(data);
}

export async function addTicketingIntegration(
  ticketingType: TTicketingIntegrationType,
  publicToken: string,
  uuid: string,
) {
  const { data } = await apiReq("POST", `/v1/company/ticketingIntegrations/${ticketingType}`, {
    configurationId: uuid,
    publicToken,
  });

  return CompanyModel.fromServerData(data);
}

export async function getMergeLinkToken(
  hrType: THRType | TTicketingIntegrationType,
): Promise<{ linkToken: string; uuid: string }> {
  const { data } = await apiReq("GET", `/v1/company/mergeLinkToken/${hrType}`);
  const { linkToken, uuid } = data;
  return { linkToken: typeof linkToken === "string" ? linkToken : "", uuid: typeof uuid === "string" ? uuid : "" };
}

export async function removeHRIntegration(hrType: THRType) {
  const { data } = await apiReq("DELETE", `/v1/company/hrIntegrations/${hrType}`);

  return CompanyModel.fromServerData(data);
}

export async function removeOnCallIntegration(onCallType: TOnCallType) {
  const { data } = await apiReq("DELETE", `/v1/company/onCallIntegrations/${onCallType}`);

  return CompanyModel.fromServerData(data);
}

export async function removeTicketingIntegration(ticketingType: TTicketingIntegrationType) {
  const { data } = await apiReq("DELETE", `/v1/company/ticketingIntegrations/${ticketingType}`);

  return CompanyModel.fromServerData(data);
}

export async function testHRIntegration(hrType: THRType) {
  const { data } = await apiReq("GET", `/v1/company/hrIntegrations/${hrType}/test`);

  return data as { errorId: string; valid: false } | { valid: true };
}
